// extracted by mini-css-extract-plugin
module.exports = {"grey":"layout_grey__2VeN4","bodyClass":"layout_bodyClass__14wqR"};